<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const {
  headlineText,
  headlineType,
  toplineText,
  toplineType,
  mainText,
  rightHeadlineText,
  boxLink,
  rightLink,
  Boxes,
} = props.content.data;
</script>
<template>
  <section class="">
    <div class="container">
      <div class="flex items-center gap-y-10 flex-col md:flex-row -mx-4">
        <div v-if="headlineText" class="w-full md:w-2/4 px-0 xl:px-4">
          <SharedTopline
            :headline="toplineText"
            :headlineType="toplineType"
          ></SharedTopline>
          <SharedHeadline
            :headline="headlineText"
            :headlineType="headlineType"
          ></SharedHeadline>
          <div class="mb-4 mt-8" v-html="mainText"></div>
          <SharedButton
            v-if="boxLink" 
            :button="boxLink"
            class="btn-outline btn-sm w-full sm:w-auto"
          ></SharedButton>
        </div>
        <div v-if="rightHeadlineText" class="w-full md:w-2/4 px-0 xl:px-4">
          <article class="bg-skin-white px-10 py-10 lg:py-[4.7rem] rounded">
            <h3 class="mb-7" v-html="rightHeadlineText"></h3>
            <div
              class="grid grid-cols-1 sm:grid-cols-2 gap-5 prose-p:text-sm prose-p:text-skin-white mb-7"
            >
              <template
                v-if="Boxes"
                v-for="(item, index) in Boxes"
                :key="index"
              >
                <div class="bg-skin-theme rounded-10 p-5">
                  <i class="block w-6 h-6 mb-5"
                    ><NuxtImg
                      v-if="item.boxImage && item.boxImage.media"
                      format="webp"
                      loading="lazy"
                      :src="item.boxImage.media.url"
                      width="30px"
                      alt=""
                  /></i>
                  <div class="text-white font-bold" v-html="item.boxText"></div>
                </div>
              </template>
            </div>            
            <SharedButton
              v-if="rightLink" 
              :button="rightLink"
              class="btn-outline w-full sm:w-auto"
            ></SharedButton>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>
